import { MutationTree } from 'vuex';
import Vue from 'vue';

import {
    IAppConfigState,
    APP_CONFIG_MODULE_TYPES
} from './app-config-types.store';

export const mutations: MutationTree<IAppConfigState> = {
    [APP_CONFIG_MODULE_TYPES.GET_FORM_DATA_CONFIG_BY_TYPE]: (state, payload: {key: string, value: any}) => {
        Vue.set(state.formDataConfigs, payload.key, payload.value);
    },
    [APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG]: (state, payload: {key: string, value: any}) => {
        Vue.set(state.systemAppConfigs, payload.key, payload.value);
    },
    [APP_CONFIG_MODULE_TYPES.SET_USER_CONFIG]: (state, payload: {key: string, value: any}) => {
        Vue.set(state.userAppConfigs, payload.key, payload.value);
    },
    [APP_CONFIG_MODULE_TYPES.UPDATE_CONFIG_VALUE]: (state, payload: {key: string, value: any}) => {
		if (state.systemAppConfigs[payload.key]) {
			Vue.set(state.systemAppConfigs, payload.key, payload.value);
		} else if (state.userAppConfigs[payload.key]) {
			Vue.set(state.userAppConfigs, payload.key, payload.value);
		}
		let configModule = '';
        for (let key in state.formDataConfigs) {
            const configs = state.formDataConfigs[key];
            for (let configKey in configs) {
                if (configKey === payload.key) {
                    configModule = key;
                    break;
                }
            }
            if (configModule) break;
        }
        if(configModule) Vue.set(state.formDataConfigs[configModule], payload.key, payload.value);
    },
}